"use client";
import { Fragment, useState, FunctionComponent, useMemo } from "react";
import { CN_PRODUCT } from "@/utils/const";
import SafeLink from "@/components/SafeLink";
import SocialX from "@/components/svg/x";
import SocialFacebook from "@/components/svg/facebook";
import { useTranslation } from "@/i18n/client";

type Props = {
  title: string;
  data?: any;
};

type svgProps = {
  link: string;
  svg: FunctionComponent<{ bgColor: string }>;
};

export default function ShareTo({ title, data }: Props) {
  const { t } = useTranslation();
  const { shareTitle } = data || {};
  const genShareMap = (windowHref: string, title: string) => {
    const href = encodeURIComponent(windowHref);
    return [
      {
        link: `https://twitter.com/intent/tweet?button_hashtag=Joybuy&ref_src=twsrc%5Etfw&url=${href}&text=${encodeURIComponent(shareTitle || "")}`,
        svg: SocialX,
      },

      {
        link: `https://www.facebook.com/sharer/sharer.php?u=${href}`,
        svg: SocialFacebook,
      },
    ];
  };

  const [style, setStyle] = useState<any>();

  const mouseEnter = (index: number) => {
    setStyle({
      [index]: {
        color: "var(--sys-color-Primary800)",
      },
    });
  };
  const mouseLeave = (index: number) => {
    setStyle({
      [index]: undefined,
    });
  };
  const socials = useMemo(() => {
    if (typeof window !== "undefined") {
      return genShareMap(window.location.href, title);
    }
    return [];
  }, [title]);
  return (
    <div className={CN_PRODUCT("nav-share")}>
      <span>{t("dp.shareTitle")}</span>
      {/*<SocialLinkIn onMouseOver={hoverBgColor}/>*/}
      {socials.map((item: svgProps, index: number) => {
        const Component = item.svg;
        const render = (
          <div className={CN_PRODUCT("social-share")} onMouseEnter={() => mouseEnter(index)} onMouseLeave={() => mouseLeave(index)} suppressHydrationWarning>
            {/*<Image src={imageSrc} alt="social icons" width={18} height={18}/>*/}
            <Component bgColor={style?.[index]?.color} />
          </div>
        );
        return (
          <Fragment key={index}>
            {item.link ? (
              <SafeLink href={item.link} passHref={true} rel="noopener noreferrer" target="_blank">
                {render}
              </SafeLink>
            ) : (
              render
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
